import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import PencilIcon from 'svg/PencilIcon';

export type EditCostTiersButtonProps = {
  onClick: () => void;
  // The customer page fetches the tier key separately from the medications, so its entry point stays
  // disabled until that query settles — the form has no way to tell an unresolved key from a genuinely
  // empty one, and would assert the empty state for a key that is merely still in flight or failed.
  disabled?: boolean;
};

// The entry point into CostTierForm, shared for the same reason the form itself is: the admin slideout's
// toolbar and the customer page's header both open it, and a duplicated affordance is how the copy and
// the icon drift apart while the form underneath them stays identical. Each surface keeps its own
// permission gate around this — the admin and customer grants are different permissions.
export default function EditCostTiersButton({ onClick, disabled = false }: EditCostTiersButtonProps) {
  return (
    <TextLinkButton type='button' onClick={onClick} disabled={disabled}>
      <PencilIcon width={16} height={16} />
      Edit Cost Tiers
    </TextLinkButton>
  );
}

// A text link rather than a button, per the design.
const TextLinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 500;
  color: ${colors.blue100};
  white-space: nowrap;
  cursor: pointer;

  &:disabled {
    color: ${colors.black50};
    cursor: default;
  }
`;
